/**
 * Currency formatting utilities for Dutch locale
 * Uses dots for thousand separators and comma for decimal
 */

// Format number with thousand separators (Dutch format: 1.234.567,89)
export const formatCurrencyInput = (value) => {
  if (value === 0 || value === "0" || value === "" || value === null || value === undefined) {
    return "0";
  }
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "0";
  return num.toLocaleString("nl-NL", { 
    minimumFractionDigits: 0, 
    maximumFractionDigits: 2 
  });
};

// Parse formatted string back to number
export const parseCurrencyInput = (str) => {
  if (!str || str === "" || str === "0") return 0;
  // Remove thousand separators (dots) and replace comma with dot for parsing
  const cleaned = str.toString().replace(/\./g, "").replace(",", ".");
  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
};

// Format as full currency display (€ 1.234,56)
export const formatCurrencyDisplay = (value, currency = "EUR") => {
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "€ 0,00";
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
};
